module.exports = __webpack_public_path__ + "static/img/3.ba42b15.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/2/1/1/zh/3.png
// module id = IQvo
// module chunks = 0